import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";

export function NotLoggedIn() {
  return (
    <div className="text-center py-24">
      <h2 className="text-2xl font-semibold">You're not part of the clan yet</h2>
      <p className="text-muted-foreground mt-2 mb-6">Log in to view your clan details, saved spots, and swim logs.</p>
      <Button asChild>
        <Link to="/login?redirect_to=/profile">
          <LogIn className="mr-2 h-4 w-4" />
          Join or Log In
        </Link>
      </Button>
    </div>
  );
}
